/**
 * VueI18n 国际化语言配置
 */
/* eslint-disable */
import Cookies from '@/utils/js-cookie'
import i18n from './i18n'
import axios from 'axios'
/**
 * 根据语言重定向 Url
 * @param {String} lang 语言标识
 */
export function setLocaleUrl(lang) {
  Cookies.set('language', lang, {
    domain: 'jd.com',
    expires: 1
  })
  let href = location.href.indexOf("language")>=0?location.href.replace(/language=([^&]*)/, `language=${lang}`):location.href.indexOf("?")>=0?`${location.href}&language=${lang}`:`${location.href}?language=${lang}`
  window.location.href = href;
  window.addEventListener('hashchange', function () {
    location.reload();
  }, false);
}

/**
 * 设置语言
 * @param {String} lang 语言标识
 */
function setLocale(lang) {
  i18n.locale = lang
  // 修改ajax请求头
  axios.defaults.headers.common['Accept-Language'] = lang
  return lang
}

/**
 * 按需加载语言文件
 * @param {String} lang 语言标识
 */
export function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    return import( /* webpackChunkName: "lang-[request]" */ `@/locale/langs/${lang}`).then(msgs => {
      i18n.setLocaleMessage(lang, msgs.default)
      return setLocale(lang)
    })
  }

  return Promise.resolve(setLocale(lang))
}